import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { templatesPath } from 'routes';
import { NewTemplate as INewTemplate } from 'types/Template';
import { useJsonboxAxios } from 'utils/jsonbox';
import { useCollection } from 'utils/useCollection';
import withCollection from 'utils/withCollection';
import NewTemplate from './NewTemplate';

const NewTemplateController: React.FC = () => {
  const { collection } = useCollection();
  const navigate = useNavigate();

  const [{ loading: postLoading }, executePost] = useJsonboxAxios(
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    },
    { manual: true },
  );

  const handleOnCancel = useCallback(() => {
    if (collection) {
      navigate(templatesPath(collection.id));
    } else {
      navigate('/');
    }
  }, [navigate, collection]);

  if (!collection) return null;

  const handleOnSave = async (template: INewTemplate) => {
    await executePost({
      url: `/${collection.id}`,
      data: template,
    });

    navigate(templatesPath(collection.id));
  };

  return <NewTemplate onCancel={handleOnCancel} onSave={handleOnSave} saving={postLoading} />;
};

export default withCollection(NewTemplateController);
